/*eslint-disable*/

import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/storage'
import functions from 'firebase/functions'

// Config Produção

var firebaseConfig = {
  apiKey: 'AIzaSyD9o_oiHv8RlugSmwuYvGU2JF42xLE47cw',
  authDomain: 'leblon-front.firebaseapp.com',
  databaseURL: 'https://leblon-front.firebaseio.com',
  projectId: 'leblon-front',
  storageBucket: 'leblon-front.appspot.com',
  messagingSenderId: '908232164154'
}

//Config Dev

// var firebaseConfig = {
//     apiKey: "AIzaSyClLDW5KG6fy7kEWi460b8aidTA5FZJHw0",
//     authDomain: "leblon-app-dev.firebaseapp.com",
//     databaseURL: "https://leblon-app-dev.firebaseio.com",
//     projectId: "leblon-app-dev",
//     storageBucket: "leblon-app-dev.appspot.com",
//     messagingSenderId: "162841134356",
//     appId: "1:162841134356:web:d87df11df691c54a"
// };

let app = firebase.initializeApp(firebaseConfig)
let db = firebase.firestore()
db.settings({
  // timestampsInSnapshots: true
})

export default {
    app: app,
    db: db
}
